import { EmailThread } from "../../../Components/MailApp/MailAppInterfaces";

export const BuckinghamMail: EmailThread[] = [
  {
    Emails: [
      {
        Date: "19 October 2024",
        Time: "12:14pm",
        Author: "The Westminster Ladies’ Circle",
        Receiver: "duchessofyork@royalfamily.co",
        Subject: "Halloween Drinks",
        Text: `Dear Arabella,

We are delighted to extend a special invitation to our esteemed members for an enchanting Halloween gathering at the Westminster Ladies' Circle. Join us for an evening of sophistication and fun, where you are encouraged to embrace your most elegant (or eerie!) attire.

The evening will feature exquisite champagne, delightful nibbles, and a charming atmosphere as we celebrate the season in style. This exclusive get-together promises to be a night of intrigue, laughter, and unforgettable memories.

Please RSVP by Sunday 27 October to secure your place.`,
        Signature: "Warm regards,\nThe Westminster Ladies' Circle Team",
        // imageContent: HalloweenHeader,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "18 October 2024",
        Time: "2.34pm",
        Author: "Saxon House",
        Receiver: "duchessofyork@royalfamily.co",
        Subject: "Tomorrow: Exclusive Drop at Saxon House",
        Text: `Dear Arabella,

We are thrilled to invite you to an exclusive, one-day-only event at Saxon House. Tomorrow, our latest collection will be unveiled at our Mayfair boutique, offering a select group of clientele the first chance to experience this highly anticipated drop. Each piece has been meticulously designed, combining timeless sophistication with modern flair, ensuring you stand apart in every setting.

Join us tomorrow for a private viewing and indulge in the artistry of fashion that speaks to the most discerning tastes.`,
        Signature: "Warm regards,\nThe Saxon House Team",
        // imageContent: SaxonHouseHeader,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "18 October 2024",
        Time: "10.19am",
        Author: "The Imperial Opera House",
        Receiver: "duchessofyork@royalfamily.co",
        Subject: "Performance of Dido and Aeneas",
        Text: `Dear Miss Wellington,

Step into the world of pure operatic emotion this March at the Royal Opera House as we present a spellbinding production of Henry Purcell’s Dido and Aeneas.
One of the greatest English operas, this timeless tragedy brings to life the heart-wrenching love story between the Queen of Carthage and the Trojan hero. With Purcell’s unforgettable music and a stirring libretto, Dido and Aeneas is a perfect marriage of baroque elegance and profound emotional depth.

Tickets go on sale online on Sunday 27 October at 9am.

We look forward to welcoming you for an unforgettable experience at the Imperial Opera House.`,
        Signature: "Best regards,\n\nImperial Opera House Team",
        // imageContent: OperaHeader,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "18 October 2024",
        Time: "7.55am",
        Author: "Bromley & Wyler",
        Receiver: "duchessofyork@royalfamily.co",
        Subject:
          "Important Update: Change in Interest Rates for Uninvested Cash",
        Text: `Dear Miss Wellington,

At Bromley & Wyler, we are committed to providing our clients with the most transparent and competitive financial solutions. We are writing to inform you that, effective from Monday 21 October, the interest rate on uninvested cash held in your account will be adjusted from 4.5% to 4.25%. This change reflects current market conditions and our continued efforts to ensure the long-term sustainability of our services.

We understand that changes in interest rates may have an impact on your financial strategy, and our team is available to discuss any questions or concerns you may have. Rest assured, Bromley & Wyler remains dedicated to offering personalized solutions and high-quality service to meet your financial goals. Should you wish to explore alternative investment options or adjust your cash holdings, please do not hesitate to reach out to your account manager.`,
        Signature: "Warm regards,\nThe Bromley & Wyler Team",
        // imageContent: BankHeader,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "17 October 2024",
        Time: "11.42am",
        Author: "Roger Lyttle",
        Receiver: "duchessofyork@royalfamily.co",
        Subject: "A note on Saturday evening’s plans",
        Text: `Dear Arabella,

This is a short note about the Queen’s birthday celebrations on Saturday evening. The event will start at 7pm, but you will be expected to arrive around half an hour early with Kasper so that you are there to greet other guests when they arrive. Your whole family will be there at this time, apart from your grandmother, who will enter the Reception Room via the grand stairs at 7:15pm on the dot.

You may enjoy your evening as you please from then on, but please remember that you will be expected in the gardens at 10:30pm to accompany your parents. Your father will say a few words and the firework display will begin. It will last 10 minutes. We will then go back inside at 10:45pm.

After that, you truly will be free to enjoy the evening as you please.`,
        Signature: "Kindest regards,\n\nRoger",
        // imageContent: RogerHeader,
      },
    ],
  },
];
